<template>
    <div class="list_config chartConfig_viewDP">
        <div class="chartDivConfig colViewConfig">
            <span class="span_til span_tilMax">表头字体颜色</span>
            <el-color-picker v-model="config.titleStyle.font.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">表头字体大小</span>
            <el-input v-model="config.titleStyle.font.fontSize" @change="getRender" type="number" min="12"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">表头字体加粗</span>
            <el-input v-model="config.titleStyle.font.fontWeight" @change="getRender" type="number"  step="100"  min="400"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表头字体系列</span>
            <el-select v-model="config.titleStyle.font.fontFamily" placeholder="请选择字体系列"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in familyList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表头对齐方式</span>
            <el-select v-model="config.titleStyle.align" placeholder="请选择对齐方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in alignList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til span_tilMax">表体字体颜色</span>
            <el-color-picker v-model="config.bodyStyle.font.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">表体字体大小</span>
            <el-input v-model="config.bodyStyle.font.fontSize" @change="getRender" type="number" min="12"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">表体字体加粗</span>
            <el-input v-model="config.bodyStyle.font.fontWeight" @change="getRender" type="number" step="100" min="400"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表体字体系列</span>
            <el-select v-model="config.bodyStyle.font.fontFamily" placeholder="请选择字体系列"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in familyList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表体对齐方式</span>
            <el-select v-model="config.bodyStyle.align" placeholder="请选择对齐方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in alignList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */

    export default {
        name: 'btn_config_config',
        components: {

        },
        data() {
            return {
                familyList:[
                    {name:'黑体',value:'SimHei'},
                    {name:'宋体',value:'SimSun'},
                    {name:'楷体',value:'KaiTi'},
                    {name:'仿宋',value:'FangSong'},
                    {name:'华文中宋',value:'STZhongsong'},
                    {name:'华文行楷',value:'STXingkai'}
                ],
                alignList:[
                    {name:'靠左对齐',value:'left'},
                    {name:'居中对齐',value:'center'},
                    {name:'靠右对齐',value:'right'}
                ],
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .list_config {
        .chartDivConfig {
            .span_til {
                max-width: 90px !important;
                width: 32% !important;
            }
            /*.span_tilMax {*/
            /*    max-width: 90px !important;*/
            /*    width: 32% !important;*/
            /*}*/

        }
    }
</style>
